import React from "react";

export function Separator({ text, className, isCenter = false }) {
  if (typeof text !== "string") {
    return null;
  }

  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-300"></div>
      </div>
      <div
        className={`relative flex ${
          !isCenter ? "justify-start" : "justify-center"
        }`}
      >
        <span className="pr-3 bg-white text-lg font-medium text-gray-900">
          {text}
        </span>
      </div>
    </div>
  );
}
